import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { EditComment } from '../containers/Community';
export default class EditCommentButton extends Component {

	state = {
		open: false
	};

	render() {
		const { item, isMobile } = this.props;
		const { open } = this.state;
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={open}
	        onClose={() => this.setState({open:false})}>
	        <div className="modalBody modal-content" style={{width: isMobile ? '70%' : 650, maxHeight: '90%', overflow: 'auto'}}>
						<ModalHeading
							text={(
								<div>
									<FontAwesomeIcon icon="edit"
										style={{marginRight: 5, color: COLORS.orange}}/>
									<span>Edit Comment</span>
								</div>

							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
						<div className="modalContent">
							<EditComment  onSaveComment={(res, isNew) => {
								this.setState({open:false})
								this.props.onSaveComment(res, isNew)
							}} item={item} topicId = {item.topicId} postId = {item.postId} isFormFields={true} editId={item._id} onClose={() => this.setState({ open: false })}  />
						</div>
	        </div>
	      </Modal>
		  <span
			className="link"
			onClick={() => this.setState({open:true})}
			style={{float:'right', color: COLORS.orange, marginLeft: isMobile && 10}}>
          <FontAwesomeIcon size={isMobile && "2x" } icon="edit" title={'Edit'}
            style={{marginRight: 5, color: COLORS.orange}}/>Edit
          </span>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EditCommentButton.js